import React from 'react';
import { Link } from 'react-router-dom';
import getPositionAbbreviation from '../../utils/getPositionAbbreviation';
import {
	playerAvatarImgClassName,
	playerListAvatarImgDimensionsStyle,
	playerListAvatarWrapperStyle
} from '../../utils/avatarClassNames';
import { playerProfilePath } from '../../utils/injuryReportHeuristics';

const POSITION_AVATAR_BG = {
	quarterback: 'from-gray-700 to-gray-900',
	'running back': 'from-green-700 to-green-900',
	'wide receiver': 'from-blue-600 to-blue-800',
	'tight end': 'from-purple-600 to-purple-800'
};

function playerInitials(player) {
	const first = (player.first_name || '').trim()[0] || '';
	const last = (player.last_name || '').trim()[0] || '';
	return (first + last).toUpperCase() || getPositionAbbreviation(player.position);
}

export function playerDisplayName(player) {
	const first = player.first_name || '';
	const last = player.last_name || '';
	const name = `${first} ${last}`.trim();
	return name || 'Unknown player';
}

function PlayerAvatar({ player }) {
	const name = playerDisplayName(player);

	if (player.image_url) {
		return (
			<div style={playerListAvatarWrapperStyle}>
				<img
					className={playerAvatarImgClassName}
					src={player.image_url + '?w=50&h=50'}
					alt={name}
					style={playerListAvatarImgDimensionsStyle}
				/>
			</div>
		);
	}

	const gradient =
		POSITION_AVATAR_BG[player.position] || 'from-gray-600 to-gray-800';

	return (
		<div style={playerListAvatarWrapperStyle}>
			<div
				className={`flex items-center justify-center rounded-full border border-gray-200 dark:border-dark-border bg-gradient-to-br ${gradient} text-xs font-bold text-white`}
				style={playerListAvatarImgDimensionsStyle}
			>
				{playerInitials(player)}
			</div>
		</div>
	);
}

function PlayerNameBlock({ player, underlineOnHover = false }) {
	const name = playerDisplayName(player);
	const nameClassName = underlineOnHover
		? 'group-hover:underline'
		: '';

	return (
		<div>
			<span className={nameClassName}>{name}</span>
			<div className="text-xs text-gray-500 dark:text-gray-400 no-underline">
				{getPositionAbbreviation(player.position)}
			</div>
		</div>
	);
}

export default function InjuryReportPlayerIdentity({
	player,
	linkToProfile = true,
	linkClassName = 'text-blue-500 no-underline group'
}) {
	const inner = (
		<div style={{ display: 'flex', alignItems: 'center' }}>
			<PlayerAvatar player={player} />
			<PlayerNameBlock player={player} underlineOnHover={linkToProfile} />
		</div>
	);

	if (!linkToProfile) return inner;

	return (
		<Link to={playerProfilePath(player)} className={linkClassName}>
			{inner}
		</Link>
	);
}
